// External modules
import React from 'react';

// Internal modules
import { getContent } from '@/lib';
import { CupOtpStyledText, InlineContentContainer } from './StyledComponents';

export const CupOtpMessage = (): JSX.Element => {
  return (
    <CupOtpStyledText data-testid="cup-otp-message">
      {getContent('oneTimePasswordConfirmation.message.initiateOtp', {
        mobileNumberOnFile: (
          <InlineContentContainer>
            {getContent(
              'oneTimePasswordConfirmation.message.mobileNumberOnFile',
            )}
          </InlineContentContainer>
        ),
      })}
    </CupOtpStyledText>
  );
};
